import { render, staticRenderFns } from "./ActivityWrapper.vue?vue&type=template&id=2bc85182&scoped=true&"
import script from "./ActivityWrapper.vue?vue&type=script&lang=js&"
export * from "./ActivityWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ActivityWrapper.vue?vue&type=style&index=0&id=2bc85182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc85182",
  null
  
)

export default component.exports